import { Env, News, Projects } from '@usimweb/core/models';
import {
  ConsentDialogComponent,
  DialogService,
  Disclaimer,
  InfoDialogComponent,
  NewsDialogComponent,
  RequestSupportDialogComponent,
  ShareDialogComponent,
} from '@usimweb/ui/dialogs';

import { AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';

import { Store } from '@ngrx/store';
import * as fromStore from '@usimweb/state/store';
import { BehaviorSubject, take } from 'rxjs';

export class DialogHandler {
  private store_: Store<fromStore.DashboardState>;
  private dialogService_: DialogService;
  private apiService_: ApiService;
  private disclaimer_: Disclaimer;

  public refreshCallback = new BehaviorSubject<string>('');
  public user!: string;

  constructor(store: Store<fromStore.DashboardState>, dialogService: DialogService, apiService: ApiService, disclaimer: Disclaimer) {
    this.store_ = store;
    this.dialogService_ = dialogService;
    this.apiService_ = apiService;
    this.user = AuthHandler.basfUserName.toLocaleLowerCase();
    this.disclaimer_ = disclaimer;
  }

  private openShareDialog(uuid: string, title: string, project: any) {
    this.dialogService_.openContentDialog(ShareDialogComponent, { uuid: uuid, title: title, project: project, user: this.user }, 'Project: ' + title);
  }

  private openDeleteDialog(project: Projects) {
    this.dialogService_.openTextDialog(InfoDialogComponent, {}, 'Delete project', 'Delete', 'Are you sure you want to delete?').subscribe((data) => {
      if (data) {
        this.store_.dispatch(new fromStore.DeleteProject(project));
      }
    });
  }

  private openSupportDialog(data: any, title: string) {
    this.dialogService_.openContentDialog(RequestSupportDialogComponent, data, title).subscribe(() => {
      this.refreshCallback.next(data.uuid);
    });
  }

  // TODO switch to header & check if dashboard is visible
  protected openNewsDialog(app: string, deployment: string) {
    this.disclaimer_.dailogClosedListener.next(false);

    console.log('env');
    console.log(app);
    console.log(deployment);

    console.log('news');

    this.apiService_.getNews().subscribe((news: News[]) => {
      console.log(news);
      if (app === 'molded' && deployment === 'ultrasimweb') {
        if (!news) {
          this.showConsentDialog();
          return;
        }
        this.showAllNews(news);
      }
    });
  }

  private showConsentDialog() {
    console.log('show consent');
    this.apiService_.getConsent().subscribe((result) => {
      console.log('consent result');
      console.log(result);
      if (!result) {
        this.dialogService_.openDialog(ConsentDialogComponent, {}, 'We need your feedback - Please provide us with your consent to contact you').subscribe(() => {});
      }
    });
  }

  private showAllNews(allNews: News[], index = 0) {
    const news = allNews[index];
    if (!news.marked_as_read) {
      this.dialogService_.openDialog(NewsDialogComponent, news, news.title).subscribe(() => {
        index = index + 1;
        if (index < allNews.length) {
          console.log('show next news');
          this.showAllNews(allNews, index);
        } else {
          console.log('show consent dialog after all news');

          this.showConsentDialog();
        }
      });
    }
  }

  protected openTouDialog(environment: Env) {
    const app = environment.APP;
    const deployment = environment.deployment;
    this.disclaimer_.project(app);
    this.disclaimer_.dailogClosedListener.pipe(take(2)).subscribe((closed) => {
      if (closed) {
        this.openNewsDialog(app, deployment);
      }
    });
  }

  public open(obj: any) {
    // const [data, name, uuid, event] = obj;
    const data = obj.data;
    const name = obj.data.name;
    const uuid = obj.uuid;
    const event = obj.event;

    if (event === 'share') {
      this.openShareDialog(uuid, name, data);
    }
    if (event === 'delete') {
      this.openDeleteDialog(data);
    }
    if (event === 'request_support') {
      const title = obj.title;
      this.openSupportDialog(data, title);
    }
    if (event === 'view_support') {
      const title = obj.title;
      this.openSupportDialog(data, title);
    }
  }
}
